import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Form, Container, Row, Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { login as loginAPI } from "../../Api/auth";
import { useAuth } from "../../AuthContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { jwtDecode } from "jwt-decode";

const AdminLoginPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { login } = useAuth();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));

    // Reset error on change
    setErrors((prev) => ({
      ...prev,
      [e.target.name]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    toast.dismiss();
    setErrors({ email: "", password: "" });

    let hasError = false;
    const newErrors = { email: "", password: "" };

    if (!formData.email) {
      const msg = t("login.emailRequired");
      toast.error(msg);
      newErrors.email = msg;
      hasError = true;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        const msg = t("login.invalidEmail");
        toast.error(msg);
        newErrors.email = msg;
        hasError = true;
      }
    }

    if (!formData.password) {
      const msg = t("login.passwordRequired");
      toast.error(msg);
      newErrors.password = msg;
      hasError = true;
    }

    if (hasError) {
      setErrors(newErrors);
      return;
    }

    setIsLoading(true);
    try {
      const response = await loginAPI(formData);

      if (response.data) {
        //  استخراج الدور من الـ token
        const decodedToken = jwtDecode(response.data.token);
        const userRole = decodedToken.role;

        if (userRole !== "Administrator") {
          toast.error("عذرًا، هذا النظام مخصص فقط لمديري النظام.");
          return;
        }

        //  تسجيل الدخول فقط إذا كان المدير
        login(response.data);
        window.dispatchEvent(new Event("user-logged-in"));

        const successMessage =
          response?.detail || response?.message || t("login.successMessage");

        toast.success(successMessage);

        setTimeout(() => {
          navigate(`/dashboard/statistics`);
        }, 3000);
      }
    } catch (error) {
      const errorMessage =
        error.detail || error.title || error.message || t("login.serverError");

      toast.error(errorMessage);

      if (errorMessage === "EmailNotConfirmed") {
        setTimeout(() => {
          navigate("/confirm-email", { state: { email: formData.email } });
        }, 3000);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className="admin-login-page d-flex align-items-center justify-content-center vh-100"
      style={{
        background: "url('/banar1.png') no-repeat center center",
        backgroundSize: "cover",
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={5}>
            <Card className="bg-white bg-opacity-75 p-4 rounded-4 shadow-lg">
              <h3 className="text-center mb-4">{t("adminLogin.title")}</h3>
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="formEmail" className="mb-3">
                  <Form.Label>{t("adminLogin.email")}</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder={t("adminLogin.emailPlaceholder")}
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formPassword" className="mb-3">
                  <Form.Label>{t("adminLogin.password")}</Form.Label>
                  <Form.Control
                    type="password"
                    name="password"
                    placeholder={t("adminLogin.passwordPlaceholder")}
                    value={formData.password}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Button
                  variant="dark"
                  type="submit"
                  className="w-100 rounded-3"
                >
                  {t("adminLogin.loginButton")}
                </Button>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </div>
  );
};

export default AdminLoginPage;
